// extracted by mini-css-extract-plugin
export default {"background":"background_background__2BLCO"};